import * as tslib_1 from "tslib";
import { Component, EventEmitter, ElementRef, Input, Output, ViewContainerRef, ViewChild, Renderer, ComponentFactoryResolver, } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { FormlyPubSub, FormlyEventEmitter, FormlyValueChangeEvent } from '../services/formly.event.emitter';
import { FormlyConfig } from '../services/formly.config';
import { evalExpression } from '../utils';
import { debounceTime } from 'rxjs/operator/debounceTime';
import { map } from 'rxjs/operator/map';
var FormlyField = (function () {
    function FormlyField(elementRef, formlyPubSub, renderer, formlyConfig, componentFactoryResolver) {
        this.elementRef = elementRef;
        this.formlyPubSub = formlyPubSub;
        this.renderer = renderer;
        this.formlyConfig = formlyConfig;
        this.componentFactoryResolver = componentFactoryResolver;
        this.options = {};
        this.modelChange = new EventEmitter();
        this.componentRefs = [];
        this._subscriptions = [];
    }
    FormlyField.prototype.ngDoCheck = function () {
        this.checkExpressionChange();
        this.checkVisibilityChange();
    };
    FormlyField.prototype.ngOnInit = function () {
        this.createFieldComponents();
        if (this.field.hide === true) {
            this.toggleHide(true);
        }
    };
    FormlyField.prototype.ngOnDestroy = function () {
        this.componentRefs.map(function (componentRef) { return componentRef.destroy(); });
        this._subscriptions.map(function (subscriber) { return subscriber.unsubscribe(); });
        this._subscriptions = this.componentRefs = [];
        if (this.field && this.field.key) {
            this.formlyPubSub.removeEmitter(this.field.key);
        }
    };
    FormlyField.prototype.changeModel = function (event) {
        this.modelChange.emit(event);
    };
    FormlyField.prototype.createFieldComponents = function () {
        var _this = this;
        if (this.field && !this.field.template && !this.field.fieldGroup && !this.field.fieldArray) {
            var debounce = 0;
            if (this.field.modelOptions && this.field.modelOptions.debounce && this.field.modelOptions.debounce.default) {
                debounce = this.field.modelOptions.debounce.default;
            }
            var fieldComponentRef = this.createFieldComponent();
            if (this.field.key) {
                var valueChanges_1 = fieldComponentRef.instance.formControl.valueChanges;
                if (debounce > 0) {
                    valueChanges_1 = debounceTime.call(valueChanges_1, debounce);
                }
                if (this.field.parsers && this.field.parsers.length > 0) {
                    this.field.parsers.map(function (parserFn) {
                        valueChanges_1 = map.call(valueChanges_1, parserFn);
                    });
                }
                this._subscriptions.push(valueChanges_1.subscribe(function (event) { return _this
                    .changeModel(new FormlyValueChangeEvent(_this.field.key, event)); }));
            }
            var update = new FormlyEventEmitter();
            this._subscriptions.push(update.subscribe(function (option) {
                _this.field.templateOptions[option.key] = option.value;
            }));
            this.formlyPubSub.setEmitter(this.field.key, update);
        }
        else if (this.field.fieldGroup || this.field.fieldArray) {
            this.createFieldComponent();
        }
    };
    FormlyField.prototype.createFieldComponent = function () {
        var _this = this;
        if (this.field.fieldGroup) {
            this.field.type = this.field.type || 'formly-group';
        }
        var type = this.formlyConfig.getType(this.field.type), wrappers = this.getFieldWrappers(type);
        var fieldComponent = this.fieldComponent;
        wrappers.map(function (wrapperName) {
            var wrapperRef = _this.createComponent(fieldComponent, _this.formlyConfig.getWrapper(wrapperName).component);
            fieldComponent = wrapperRef.instance.fieldComponent;
        });
        return this.createComponent(fieldComponent, type.component);
    };
    FormlyField.prototype.getFieldWrappers = function (type) {
        var _this = this;
        var templateManipulators = {
            preWrapper: [],
            postWrapper: [],
        };
        if (this.field.templateOptions) {
            this.mergeTemplateManipulators(templateManipulators, this.field.templateOptions.templateManipulators);
        }
        this.mergeTemplateManipulators(templateManipulators, this.formlyConfig.templateManipulators);
        var preWrappers = templateManipulators.preWrapper.map(function (m) { return m(_this.field); }).filter(function (type) { return type; }), postWrappers = templateManipulators.postWrapper.map(function (m) { return m(_this.field); }).filter(function (type) { return type; });
        if (!this.field.wrappers)
            this.field.wrappers = [];
        if (!type.wrappers)
            type.wrappers = [];
        if (this.field.wrapper) {
            console.warn(this.field.key + ": wrapper is deprecated. Use 'wrappers' instead.");
            this.field.wrappers = Array.isArray(this.field.wrapper) ? this.field.wrapper : [this.field.wrapper];
        }
        return preWrappers.concat(this.field.wrappers, postWrappers);
    };
    FormlyField.prototype.mergeTemplateManipulators = function (source, target) {
        target = target || {};
        if (target.preWrapper) {
            source.preWrapper = source.preWrapper.concat(target.preWrapper);
        }
        if (target.postWrapper) {
            source.postWrapper = source.postWrapper.concat(target.postWrapper);
        }
        return source;
    };
    FormlyField.prototype.createComponent = function (fieldComponent, component) {
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        var ref = fieldComponent.createComponent(componentFactory);
        Object.assign(ref.instance, {
            model: this.model,
            form: this.form,
            field: this.field,
            options: this.options,
        });
        this.componentRefs.push(ref);
        return ref;
    };
    FormlyField.prototype.psEmit = function (fieldKey, eventKey, value) {
        if (this.formlyPubSub && this.formlyPubSub.getEmitter(fieldKey) && this.formlyPubSub.getEmitter(fieldKey).emit) {
            this.formlyPubSub.getEmitter(fieldKey).emit(new FormlyValueChangeEvent(eventKey, value));
        }
    };
    FormlyField.prototype.checkVisibilityChange = function () {
        if (this.field && this.field.hideExpression) {
            var hideExpressionResult = !!evalExpression(this.field.hideExpression, this, [this.model, this.options.formState]);
            if (hideExpressionResult !== this.field.hide) {
                this.toggleHide(hideExpressionResult);
            }
        }
    };
    FormlyField.prototype.checkExpressionChange = function () {
        if (this.field && this.field.expressionProperties) {
            var expressionProperties = this.field.expressionProperties;
            for (var key in expressionProperties) {
                var expressionValue = evalExpression(expressionProperties[key].expression, this, [this.model, this.options.formState]);
                if (expressionProperties[key].expressionValue !== expressionValue) {
                    expressionProperties[key].expressionValue = expressionValue;
                    evalExpression(expressionProperties[key].expressionValueSetter, this, [expressionValue, this.model, this.field.templateOptions, this.field.validation]);
                }
            }
            var formControl = this.field.formControl;
            if (formControl) {
                if (formControl.status === 'DISABLED' && !this.field.templateOptions.disabled) {
                    formControl.enable();
                }
                if (formControl.status !== 'DISABLED' && this.field.templateOptions.disabled) {
                    formControl.disable();
                }
                if (!formControl.dirty && formControl.invalid && this.field.validation && !this.field.validation.show) {
                    formControl.markAsUntouched();
                }
                if (!formControl.dirty && formControl.invalid && this.field.validation && this.field.validation.show) {
                    formControl.markAsTouched();
                }
            }
        }
    };
    FormlyField.prototype.toggleHide = function (value) {
        var _this = this;
        this.field.hide = value;
        if (this.field.formControl) {
            if (value === true && this.form.get(this.field.key)) {
                setTimeout(function () { return _this.removeFieldControl(); });
            }
            else if (value === false && !this.form.get(this.field.key)) {
                setTimeout(function () { return _this.addFieldControl(); });
            }
        }
        this.renderer.setElementStyle(this.elementRef.nativeElement, 'display', value ? 'none' : '');
        if (this.field.fieldGroup) {
            for (var i = 0; i < this.field.fieldGroup.length; i++) {
                this.psEmit(this.field.fieldGroup[i].key, 'hidden', value);
            }
        }
        else {
            this.psEmit(this.field.key, 'hidden', value);
        }
    };
    Object.defineProperty(FormlyField.prototype, "fieldKey", {
        get: function () {
            return this.field.key.split('.').pop();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormlyField.prototype, "fieldParentFormControl", {
        get: function () {
            var paths = this.field.key.split('.');
            paths.pop();
            return (paths.length > 0 ? this.form.get(paths) : this.form);
        },
        enumerable: true,
        configurable: true
    });
    FormlyField.prototype.addFieldControl = function () {
        var parent = this.fieldParentFormControl;
        if (parent instanceof FormArray) {
            parent.push(this.field.formControl);
        }
        else if (parent instanceof FormGroup) {
            parent.addControl(this.fieldKey, this.field.formControl);
        }
    };
    FormlyField.prototype.removeFieldControl = function () {
        var parent = this.fieldParentFormControl;
        if (parent instanceof FormArray) {
            parent.removeAt(this.fieldKey);
        }
        else if (parent instanceof FormGroup) {
            parent.removeControl(this.fieldKey);
        }
    };
    return FormlyField;
}());
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], FormlyField.prototype, "model", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", FormGroup)
], FormlyField.prototype, "form", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], FormlyField.prototype, "field", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], FormlyField.prototype, "options", void 0);
tslib_1.__decorate([
    Output(),
    tslib_1.__metadata("design:type", EventEmitter)
], FormlyField.prototype, "modelChange", void 0);
tslib_1.__decorate([
    ViewChild('fieldComponent', { read: ViewContainerRef }),
    tslib_1.__metadata("design:type", ViewContainerRef)
], FormlyField.prototype, "fieldComponent", void 0);
FormlyField = tslib_1.__decorate([
    Component({
        selector: 'formly-field',
        template: "\n    <ng-container #fieldComponent></ng-container>\n    <div *ngIf=\"field.template && !field.fieldGroup\" [innerHtml]=\"field.template\"></div>\n  ",
    }),
    tslib_1.__metadata("design:paramtypes", [ElementRef,
        FormlyPubSub,
        Renderer,
        FormlyConfig,
        ComponentFactoryResolver])
], FormlyField);
export { FormlyField };
//# sourceMappingURL=formly.field.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/components/formly.field.js
// module id = 323
// module chunks = 3